export const ALL_BODY_SHAPES = 'All Body shapes';
export const ALL_BODY_TYPES = 'All body types';
